import React, { useEffect, useState } from "react";
import { getUserProfile } from "../utilities/axios.utilities";
import PopupCard, { PopupCardName } from "./PopupCard";

interface IProps {}

const Header: React.FC<IProps> = () => {
  const [userInfo, setUserInfo] = useState<{
    userName: string;
    coins: number;
  } | null>(null);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false,
  );
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isShowLogout, setIsShowLogout] = useState(false);
  const Cookies = require("js-cookie");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getUserProfile();
        const info = {
          coins: data.coins,
          role: data.role,
          userName: data.username,
        };
        localStorage.setItem("user_info", JSON.stringify(info));
        setUserInfo({ userName: info.userName, coins: info.coins });
      } catch (err) {
        console.error("Error fetching user profile:", err);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="w-full h-[80px]">
      <header
        className="menu-lobby py-3 md:mb-9 mb-3"
        style={{
          background:
            "linear-gradient(290.13deg, #172EA2 0.11%, #00B3FF 99.34%)",
          borderBottom: "2px solid #fff",
        }}
      >
        <nav className="navbar navbar-expand-lg navbar-dark flex items-center justify-between md:justify-around px-4 gap-4 relative">
          <a className="navbar-brand md:items-center md:flex hidden" href="/">
            <img
              className="!w-[180px] md:!w-[220px] lg:!w-[260px]"
              src="/assets/common/logo.png"
              alt="KINGNOHU"
            />
          </a>

          {/* Desktop layout: 3 item hiển thị trực tiếp */}
          {!isMobile && (
            <div className="flex items-center gap-4 text-white">
              {userInfo && (
                <>
                  <div
                    className="flex items-center gap-3 px-3 py-1 rounded-full "
                    style={{
                      background:
                        "linear-gradient(90deg, #FFFFFF 0%, #63D0FE 100%)",
                      border: "2.35px solid transparent",
                      backgroundImage:
                        "linear-gradient(#FFFFFF, #63D0FE), linear-gradient(90deg, #FFFFFF 0%, #CAEBFF 100%)",
                      backgroundOrigin: "border-box",
                      backgroundClip: "padding-box, border-box",
                    }}
                  >
                    <img
                      src="/assets/home-icon.png"
                      alt="user"
                      className="w-8 h-8"
                    />
                    <a
                      href="/"
                      className="text-base font-semibold text-[#011474] cursor-pointer"
                    >
                      Trang chủ
                    </a>
                  </div>
                  <div
                    className="flex items-center gap-3 px-3 py-1 rounded-full "
                    style={{
                      background:
                        "linear-gradient(90deg, #FFFFFF 0%, #63D0FE 100%)",
                      border: "2.35px solid transparent",
                      backgroundImage:
                        "linear-gradient(#FFFFFF, #63D0FE), linear-gradient(90deg, #FFFFFF 0%, #CAEBFF 100%)",
                      backgroundOrigin: "border-box",
                      backgroundClip: "padding-box, border-box",
                    }}
                  >
                    <img
                      src="/assets/user-icon.png"
                      alt="user"
                      className="w-8 h-8"
                    />
                    <span className="text-base font-semibold text-[#011474]">
                      {userInfo.userName}
                    </span>
                  </div>
                  <div
                    className="flex items-center gap-3 px-3 py-1 rounded-full "
                    style={{
                      background:
                        "linear-gradient(90deg, #FFFFFF 0%, #63D0FE 100%)",
                      border: "2.35px solid transparent",
                      backgroundImage:
                        "linear-gradient(#FFFFFF, #63D0FE), linear-gradient(90deg, #FFFFFF 0%, #CAEBFF 100%)",
                      backgroundOrigin: "border-box",
                      backgroundClip: "padding-box, border-box",
                    }}
                  >
                    <img
                      src="/assets/coins.png"
                      alt="coins"
                      className="w-8 h-8"
                    />
                    <span className="text-base font-semibold">
                      {userInfo.coins.toLocaleString("vi-VN")}
                    </span>
                  </div>
                </>
              )}
              <button
                type="button"
                onClick={() => setIsShowLogout(true)}
                className="flex items-center gap-3 text-white font-semibold px-3 py-1 rounded-full"
                style={{
                  background:
                    "linear-gradient(90deg, #FF3300 0%, #680000 100%)",
                  border:
                    "2.35px solid linear-gradient(119.28deg, #8D0000 -7.49%, #480000 70.18%)",
                  boxShadow: "-0.78px -6.26px 3.52px 0px #FF0000 inset",
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 32,
                    height: 32,
                    borderRadius: "9999px",
                    backgroundColor: "#ffffff",
                  }}
                >
                  <img
                    src="/assets/logout.png"
                    alt="logout"
                    className="w-5 h-5"
                  />
                </span>
                <span className="text-base font-semibold">Đăng xuất</span>
              </button>
            </div>
          )}

          {/* Mobile layout: icon navbar-icon mở menu 3 item */}
          {isMobile && (
            <>
              <button
                type="button"
                onClick={() => setIsMenuOpen((prev) => !prev)}
                className="flex items-center justify-center w-10 h-10 rounded-md border border-red-600 bg-black/40"
              >
                <img
                  src="/assets/navbar-icon.png"
                  alt="menu"
                  className="w-8 h-8 object-contain"
                />
              </button>
              <a
                className="absolute left-1/2 -translate-x-1/2 md:hidden"
                href="/"
              >
                <img
                  className="!w-[180px] md:!w-[220px] lg:!w-[260px]"
                  src="/assets/common/logo.png"
                  alt="LOGO"
                />
              </a>
              {isMenuOpen && (
                <div
                  className="absolute left-4 top-[64px] z-50 flex flex-col gap-2 text-white px-3 py-3 rounded-lg"
                  style={{
                    background:
                      "linear-gradient(290.13deg, #172EA2 0.11%, #00B3FF 99.34%)",
                    borderBottom: "2px solid #fff",
                  }}
                >
                  {userInfo && (
                    <>
                      <div className="flex items-center gap-2 px-2 py-1 rounded-md  border border-white">
                        <img
                          src="/assets/user-icon.png"
                          alt="user"
                          className="w-7 h-7"
                        />
                        <span className="text-sm font-semibold truncate">
                          {userInfo.userName}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 px-2 py-1 rounded-md  border border-white">
                        <img
                          src="/assets/coins.png"
                          alt="coins"
                          className="w-7 h-7"
                        />
                        <span className="text-sm font-semibold">
                          {userInfo.coins.toLocaleString("vi-VN")}
                        </span>
                      </div>
                    </>
                  )}
                  <button
                    type="button"
                    onClick={() => {
                      setIsMenuOpen(false);
                      setIsShowLogout(true);
                    }}
                    className="flex items-center justify-center gap-2 text-white font-semibold px-3 py-2 rounded-md"
                    style={{
                      background:
                        "linear-gradient(90deg, #FF3300 0%, #680000 100%)",
                      border:
                        "2.35px solid linear-gradient(119.28deg, #8D0000 -7.49%, #480000 70.18%)",
                      boxShadow: "-0.78px -6.26px 3.52px 0px #FF0000 inset",
                    }}
                  >
                    <img
                      src="/assets/logout.png"
                      alt="logout"
                      className="w-5 h-5"
                    />
                    <span className="text-sm font-semibold">Đăng xuất</span>
                  </button>
                </div>
              )}
            </>
          )}
        </nav>
      </header>
      {isShowLogout && (
        <PopupCard
          name={PopupCardName.Logout}
          text="Bạn có chắc muốn đăng xuất không?"
          onClose={() => setIsShowLogout(false)}
          onLogout={() => {
            Cookies.remove("access_token");
            setIsShowLogout(false);
            localStorage.removeItem("user_info");
            window.location.reload();
          }}
        />
      )}
    </div>
  );
};

export default Header;
